"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceId = void 0;
var ServiceId;
(function (ServiceId) {
    ServiceId["AssuranceWine"] = "assurance-wine";
    ServiceId["Faciliti"] = "facil-iti";
    ServiceId["Fevad"] = "fevad";
    ServiceId["EcommerceEU"] = "ecommerce-eu";
    ServiceId["Sourdline"] = "sourdline";
})(ServiceId || (exports.ServiceId = ServiceId = {}));
